module.exports = __webpack_public_path__ + "static/img/200251.79abdf56.png";